import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import SideBar from "../components/SideBar/SideBar";
import Stepper from "../components/Stepper/Stepper";
import { getSystemDate } from "../redux/otherProjectsSlice/otherProjectsSlice";

const SIDEBAR_WIDTH = "260px";

const MainLayout = () => {
  const { pathname } = useLocation();
  const [collapsible, setCollapsible] = React.useState(false);
  const dispatch = useDispatch();
  const { systemDate, systemDateLoading } = useSelector((state) => state.otherProjects);

  const projectCost = pathname.includes("project-cost");

  React.useEffect(() => {
    if (!systemDate && !systemDateLoading) {
      dispatch(getSystemDate());
    }
  }, [dispatch, systemDate, systemDateLoading]);

  return (
    <div className="flex h-screen relative">
      {/* Sidebar / Stepper */}
      <div
        className={`${
          collapsible ? "w-0" : "w-[260px]"
        } transition-all duration-300 ease-in-out overflow-hidden bg-white`}
      >
        {projectCost ? <Stepper /> : <SideBar />}
      </div>

      {/* Toggle Button */}
      <button
        onClick={() => setCollapsible((p) => !p)}
        className="fixed top-6 z-50 p-2 bg-white shadow-md rounded-full hover:bg-gray-100 transition-all duration-300"
        style={
          collapsible
            ? {
                right: "16px",
              }
            : {
                left: SIDEBAR_WIDTH,
                transform: "translateX(-50%)",
              }
        }
        aria-label="Toggle Sidebar"
      >
        <MenuOutlined
          style={{
            fontSize: "22px",
            color: "#374151",
            transform: collapsible ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        />
      </button>

      {/* Content Area */}
      <div
        className={`flex-1 h-screen overflow-y-auto bg-[#FCFCFD] border-t border-l transition-all duration-300 ${
          collapsible ? "" : "rounded-tl-[40px]"
        }`}
      >
        <main className="h-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
